import { styles } from './template.scss';
import { FontSizes, LineHeights } from '../../../../../types/common/types';
import { InputWidthValues } from '../../../../../ui/gzInput';

export const templateMdrContactDetailsForm = document.createElement('template');

templateMdrContactDetailsForm.innerHTML = `
  <style>${styles}</style>
  <div class='wrapper'>
    <div class='content-wrapper'>
      <div class='form-wrapper'>
        <!-- Full Name -->
        <gz-form-field id='full-name-form-field' class='mb-2 label-mw-250' required>
          <gz-input gz-form-input inputWidth=${InputWidthValues.LARGE}></gz-input>
          <gz-input-error></gz-input-error>
        </gz-form-field>
        <!-- Email Address -->
        <gz-text id='email-verification-disclaimer' fontSize='${FontSizes.PARAGRAPH_12}' lineHeight='${LineHeights.NORMAL}'></gz-text>
        <gz-form-field id='email-address-form-field' class='label-mw-250' required>
          <div id='email-address-mini-form'>
            <div id='email-address-input'>
              <gz-input gz-form-input inputWidth=${InputWidthValues.LARGE}></gz-input>
              <gz-input-error></gz-input-error>
            </div>
            <div id="send-verification-code-button-wrapper">
              <gz-button
                id='send-verification-code-button'
                class='ml-1'
                type='quiet'
                buttonHeight='small'
                buttonFontSize='small'
                lowercase='true'
              ></gz-button>
            </div>
          </div>
        </gz-form-field>
        <!-- Hidden checkbox used in form validation -->
        <gz-form-field id='has-verified-email-address-form-field'>
          <gz-checkbox gz-form-input></gz-checkbox>
        </gz-form-field>
        <!-- Verification Code -->
        <gz-form-field id='verification-code-form-field' class='label-mw-250' required>
          <gz-input gz-form-input inputWidth=${InputWidthValues.LARGE}></gz-input>
          <gz-input-error></gz-input-error>
        </gz-form-field>
        <!-- Phone Number -->
        <gz-form-field id='phone-number-form-field' class='label-mw-250' required>
          <gz-phone-input gz-form-input></gz-phone-input>
          <gz-input-error></gz-input-error>
        </gz-form-field>
      </div>
      <!-- Clear Data -->
      <gz-button
        id='clear-data-button'
        type='outline'
        color='negative'
        buttonHeight='small'
        buttonFontSize='small'
        lowercase='true'
      ></gz-button>
  </div>
`;
